import React, {MouseEvent} from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import FolderItemState from 'filestate/FolderItemState';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import * as TestOrderContextMenu from 'sample-tests/search/TestOrderContextMenu';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {TestOrderListingGraphQL} from '../../../graphql-fragments/sample_tests/__generated/TestOrderListingGraphQL';

interface TestOrderSidepanelItemProps {
  testOrder: TestOrderListingGraphQL;
  isActive: boolean;
  isCompact: boolean;
  isChild: boolean;
  openResult: (item: TestOrderListingGraphQL) => void;
}

export default function TestOrderSidepanelItem(props: TestOrderSidepanelItemProps): JSX.Element {
  const {isActive, isCompact, isChild, testOrder} = props;
  const icon = <BenchlingIcon icon={ModelTypeConstants.TEST_ORDER} />;

  const handleOpenContextMenu = (e: MouseEvent): void => {
    TestOrderContextMenu.open(e.nativeEvent, props.testOrder);
  };

  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      faded={false}
      icon={icon}
      isCompact={isCompact}
      onClick={() => {
        FileBrowserActions.openFile(testOrder.sample.id, {
          onOpen: (fileState: FolderItemState) => {
            fileState.activateTestOrdersTab();
          },
        });
      }}
      onContextMenu={handleOpenContextMenu}
      title={{text: testOrder.name}}
      tooltipText={testOrder.name}
      isExpandable={false}
      isChild={isChild}
    />
  );
}
